// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outgoing-request-modal .modal-dialog {
  max-width: 809px !important;
  width: 809px !important;
}

.outgoing-request-modal .modal-content {
  width: 100%;
  border-radius: 8px;
  padding: 0;
}

.outgoing-request-modal .modal-header {
  padding: 24px 40px;
  border-bottom: none;
  text-align: center;
}

.outgoing-request-modal .modal-body {
  padding: 0 40px 24px 40px;
}

.outgoing-request-modal .form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.outgoing-request-modal .form-row .form-group {
  flex: 1 1;
}

.outgoing-request-modal .form-group {
  margin-bottom: 0;
}

.outgoing-request-modal .form-group.full-width {
  width: 100%;
  margin-bottom: 24px;
}

.outgoing-request-modal .modal-label-txt {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #27272a;
  font-size: 14px;
}

.outgoing-request-modal .form-control,
.outgoing-request-modal .form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  font-size: 14px;
  background-color: #fff;
}

.outgoing-request-modal .form-control:focus,
.outgoing-request-modal .form-select:focus {
  border-color: #28a745;
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.outgoing-request-modal .file-upload-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fff;
  transition: border-color 0.2s;
}

.outgoing-request-modal .file-upload-area:hover {
  border-color: #28a745;
}

.outgoing-request-modal .file-upload-area .upload-icon {
  color: #6c757d;
  font-size: 18px;
}

.outgoing-request-modal .file-upload-area .upload-text {
  color: #27272a;
  font-size: 14px;
}

.outgoing-request-modal .date-input-wrapper {
  position: relative;
}

.outgoing-request-modal .date-input-wrapper .calendar-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  pointer-events: none;
  z-index: 1;
}

.outgoing-request-modal .date-input-wrapper input {
  padding-right: 40px;
}

.outgoing-request-modal textarea {
  resize: vertical;
  min-height: 80px;
}

.outgoing-request-modal .modal-footer {
  padding: 24px 40px;
  border-top: none;
  justify-content: center;
}

.outgoing-request-modal .submit-btn {
  width: 200px;
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.outgoing-request-modal .submit-btn:hover {
  background-color: #218838;
}

@media (max-width: 768px) {
  .outgoing-request-modal .modal-dialog {
    max-width: 95% !important;
    width: 95% !important;
  }
  
  .outgoing-request-modal .modal-header,
  .outgoing-request-modal .modal-body,
  .outgoing-request-modal .modal-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
  
  .outgoing-request-modal .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .outgoing-request-modal .form-row .form-group {
    margin-bottom: 24px;
  }
  
  .outgoing-request-modal .form-row .form-group:last-child {
    margin-bottom: 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/CommonComponents/OutgoingRequest.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".outgoing-request-modal .modal-dialog {\n  max-width: 809px !important;\n  width: 809px !important;\n}\n\n.outgoing-request-modal .modal-content {\n  width: 100%;\n  border-radius: 8px;\n  padding: 0;\n}\n\n.outgoing-request-modal .modal-header {\n  padding: 24px 40px;\n  border-bottom: none;\n  text-align: center;\n}\n\n.outgoing-request-modal .modal-body {\n  padding: 0 40px 24px 40px;\n}\n\n.outgoing-request-modal .form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.outgoing-request-modal .form-row .form-group {\n  flex: 1;\n}\n\n.outgoing-request-modal .form-group {\n  margin-bottom: 0;\n}\n\n.outgoing-request-modal .form-group.full-width {\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.outgoing-request-modal .modal-label-txt {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #27272a;\n  font-size: 14px;\n}\n\n.outgoing-request-modal .form-control,\n.outgoing-request-modal .form-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  font-size: 14px;\n  background-color: #fff;\n}\n\n.outgoing-request-modal .form-control:focus,\n.outgoing-request-modal .form-select:focus {\n  border-color: #28a745;\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.outgoing-request-modal .file-upload-area {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  cursor: pointer;\n  background-color: #fff;\n  transition: border-color 0.2s;\n}\n\n.outgoing-request-modal .file-upload-area:hover {\n  border-color: #28a745;\n}\n\n.outgoing-request-modal .file-upload-area .upload-icon {\n  color: #6c757d;\n  font-size: 18px;\n}\n\n.outgoing-request-modal .file-upload-area .upload-text {\n  color: #27272a;\n  font-size: 14px;\n}\n\n.outgoing-request-modal .date-input-wrapper {\n  position: relative;\n}\n\n.outgoing-request-modal .date-input-wrapper .calendar-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.outgoing-request-modal .date-input-wrapper input {\n  padding-right: 40px;\n}\n\n.outgoing-request-modal textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.outgoing-request-modal .modal-footer {\n  padding: 24px 40px;\n  border-top: none;\n  justify-content: center;\n}\n\n.outgoing-request-modal .submit-btn {\n  width: 200px;\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.outgoing-request-modal .submit-btn:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 768px) {\n  .outgoing-request-modal .modal-dialog {\n    max-width: 95% !important;\n    width: 95% !important;\n  }\n  \n  .outgoing-request-modal .modal-header,\n  .outgoing-request-modal .modal-body,\n  .outgoing-request-modal .modal-footer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  \n  .outgoing-request-modal .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .outgoing-request-modal .form-row .form-group {\n    margin-bottom: 24px;\n  }\n  \n  .outgoing-request-modal .form-row .form-group:last-child {\n    margin-bottom: 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
